var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxtFooterLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_106506)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1168_106506",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10C0 4.47715 4.47715 0 10 0H30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1168_106506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "#FF1844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10C0 4.47715 4.47715 0 10 0Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1168_106506",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5834 10V12.5899C20.5834 13.9078 21.4541 15.4614 23.5781 15.4614L24.9412 15.4624C28.5202 15.4709 28.7657 15.5536 29.2972 16.36C29.4452 17.0038 29.0649 18.602 29.7475 19.2096C30.4301 19.8172 29.5388 20.5652 29.2972 22.2044C29.0556 23.8436 26.7958 24.4227 25.6855 25.2175C24.5751 26.0124 24.6734 27.5133 24.6734 30C23.1283 30 21.8957 29.6644 21.5319 28.3913C21.1681 27.1181 21.1193 26.6595 20.5834 26.1074C20.0475 25.5553 19.7971 25.4723 19.1668 24.1628C18.5364 22.8533 17.8911 22.5711 16.9405 22.5711C15.9898 22.5711 15.4262 23.2098 15.1792 23.9995C14.5753 23.9995 14.1524 23.6499 13.6785 22.5711C13.2046 21.4924 12.7574 20.6452 11.7512 20.3544C11.0804 20.1606 10.4967 19.4554 10 18.2389H16.0138V10H20.5834Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1168_106506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10H30V30H10V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0138 10V18.2389H10C10.4967 19.4554 11.0804 20.1606 11.7512 20.3544C12.7574 20.6452 13.2046 21.4924 13.6785 22.5711C14.1524 23.6499 14.5753 23.9995 15.1792 23.9995C15.4262 23.2098 15.9898 22.5711 16.9405 22.5711C17.8911 22.5711 18.5364 22.8533 19.1668 24.1628C19.7971 25.4723 20.0475 25.5553 20.5834 26.1074C21.1193 26.6595 21.1681 27.1181 21.5319 28.3913C21.8957 29.6644 23.1283 30 24.6734 30C24.6734 27.5133 24.5751 26.0124 25.6855 25.2175C26.7958 24.4227 29.0556 23.8436 29.2972 22.2044C29.5388 20.5652 30.4301 19.8172 29.7475 19.2096C29.0649 18.602 29.4452 17.0038 29.2972 16.36C28.7049 15.4614 28.4679 15.4614 23.5781 15.4614C21.4541 15.4614 20.5834 13.9078 20.5834 12.5899C20.5834 11.7113 20.5834 10.848 20.5834 10H16.0138Z",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_106506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtFooterLogo);
export default __webpack_public_path__ + "static/media/txt-footer-logo.cb6ff8587e12c7ba640154eecc680394.svg";
export { ForwardRef as ReactComponent };